import Cookies from 'js-cookie'

const app = {
  state: {
    moduleId: undefined,
    moduleName: Cookies.get('moduleName') || '',
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh_CN',
    language2: Cookies.get('language2') || 'zh_CN',
    size: Cookies.get('size') || 'medium'
  },
  mutations: {
    SET_MODULEID: (state, moduleId) => {
      state.moduleId = moduleId
    },
    SET_MODULENAME: (state, moduleName) => {
      state.moduleName = moduleName
      Cookies.set('moduleName', moduleName)
    },
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_LANGUAGE2: (state, language) => {
      state.language2 = language
      Cookies.set('language2', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    }
  },
  actions: {
    setModuleID({ commit }, moduleId) {
      commit('SET_MODULEID', moduleId)
    },
    setModuleName({ commit }, moduleName) {
      commit('SET_MODULENAME', moduleName)
    },
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setLanguage2({ commit }, language) {
      commit('SET_LANGUAGE2', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js